<template>
  <div class="relative p-4 border rounded-10 border-slate-300 dark:border-zinc-700 flex flex-col items-center">
    <div class="text-slate-400 dark:text-zinc-900 bg-slate-100 dark:bg-zinc-700 p-2.5 rounded-full my-5">
      <Icon class="dark:text-zinc-500" name="general.exclamationTriangle" />
    </div>
    <h2 class="dark:text-zinc-500 text-3xl mb-5">Transcription failed</h2>
    <span class="dark:text-zinc-500 mb-5">There was a problem generating your transcription. Please, try again.</span>
    <Button class="mb-2" :disabled="isLoading" :loading="isLoading" @click="requestTranscription">Retry transcription</Button>
  </div>
</template>

<script lang="ts" setup>
import { Button } from '@/storybook/button';
import { Icon } from '@/storybook/icon';
import { useTrack, TrackEvents } from '@/composables/useTrack';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { ref } from 'vue';
import { useToast } from '@/composables/useToast';
import { useDebug } from '@/composables/useDebug';

const transcriptionStore = useTranscriptionStore();
const isLoading = ref(false);

const { error } = useToast();
const { debug } = useDebug('TranscriptionRequest');
const { track } = useTrack();

const requestTranscription = () => {
  isLoading.value = true;

  return transcriptionStore
    .retryTranscription()
    .then(() => {
      isLoading.value = false;
      track(TrackEvents.VIEWER_TRANSCRIPTION_REQUEST);
    })
    .catch(e => {
      isLoading.value = false;
      debug('Backend error', e);
      error('Cannot request transcription. Please try again later.');
    });
};
</script>
